import { render, staticRenderFns } from "./ModalAlunosProximoMes.vue?vue&type=template&id=70938b02&"
import script from "./ModalAlunosProximoMes.vue?vue&type=script&lang=js&"
export * from "./ModalAlunosProximoMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports